import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function AboutPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="w-full">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于我们 - 开云足球',
            description: '了解开云足球的品牌故事、核心价值和联系方式。',
            url: 'https://kaiyun-football.com/about',
            isPartOf: {
              '@type': 'WebSite',
              name: '开云足球',
              url: 'https://kaiyun-football.com/',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'https://kaiyun-football.com/',
                },
                {
                  '@type': 'ListItem',
                  position: 2,
                  name: '关于我们',
                  item: 'https://kaiyun-football.com/about',
                },
              ],
            },
          }),
        }}
      />

      <section className="relative w-full h-[240px] md:h-[340px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20football%20team%20silhouette%20against%20dramatic%20sunset%20sky%2C%20warm%20golden%20and%20green%20lighting%20accents%2C%20professional%20sports%20photography%20with%20emotional%20resonance%2C%20unity%20and%20teamwork%20symbolism%2C%20editorial%20quality%20composition%20with%20rich%20atmosphere&width=1800&height=500&seq=kaiyun-about-bg&orientation=landscape"
            alt="关于开云足球"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
        </div>
        <div className="relative z-10 text-center px-4">
          <h1 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-3">
            关于我们
          </h1>
          <p className="text-background-300 text-sm md:text-base max-w-lg mx-auto">
            了解开云足球的品牌故事、核心价值与企业文化
          </p>
        </div>
      </section>

      <section className="w-full py-12 md:py-20 px-4 md:px-6 bg-background-50">
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
          <div className="rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20football%20technology%20hub%20with%20multiple%20screens%20showing%20live%20matches%20and%20data%20analytics%2C%20dark%20sophisticated%20interior%20with%20green%20and%20gold%20accent%20lighting%2C%20professional%20sports%20tech%20control%20room%20aesthetic%2C%20sleek%20and%20modern%20workspace%20design&width=800&height=600&seq=kaiyun-about-brand&orientation=landscape"
              alt="开云足球品牌"
              className="w-full h-auto object-cover"
            />
          </div>
          <div>
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
              品牌介绍
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
              专注足球，致力于极致体验
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
              开云足球成立于2020年，是一家专注于足球赛事服务、数据分析和互动体验的综合性数字平台。我们汇聚了来自全球顶尖的体育数据分析师、AI技术专家和资深足球编辑，致力于为用户提供最专业、最及时的足球内容与服务。
            </p>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
              我们相信，足球不仅仅是一项运动，更是一种文化、一种信仰、一种连接全球数亿人的情感纽带。开云足球的使命是让每一位足球爱好者都能获得极致的观赛体验和深度的足球洞察。
            </p>
            <div className="grid grid-cols-2 gap-4">
              <div className="p-4 rounded-xl bg-background-100">
                <p className="font-heading text-2xl font-bold text-primary-600">200万+</p>
                <p className="text-foreground-500 text-xs mt-1">注册用户</p>
              </div>
              <div className="p-4 rounded-xl bg-background-100">
                <p className="font-heading text-2xl font-bold text-primary-600">50+</p>
                <p className="text-foreground-500 text-xs mt-1">覆盖联赛</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="reputation" className="w-full py-12 md:py-20 px-4 md:px-6 bg-background-100">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
              信誉保障
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              值得信赖的平台
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
              开云足球以安全、透明、公正的经营理念，赢得了广大用户的信赖与好评
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {[
              {
                icon: 'ri-shield-check-line',
                title: '安全合规',
                desc: '获得多项国际认证，采用银行级加密技术保护用户数据与交易安全。',
              },
              {
                icon: 'ri-shield-star-line',
                title: '公正透明',
                desc: '所有竞猜玩法均采用公开算法与区块链存证，确保结果可追溯、可验证。',
              },
              {
                icon: 'ri-customer-service-2-line',
                title: '专业服务',
                desc: '7×24小时在线客服团队，平均响应时间低于30秒，专业解决各类问题。',
              },
              {
                icon: 'ri-award-line',
                title: '行业认可',
                desc: '荣获年度最佳体育平台、最具创新力足球服务等多项行业大奖。',
              },
            ].map((item) => (
              <div key={item.title} className="p-6 md:p-7 rounded-2xl bg-background-50 text-center">
                <div className="w-14 h-14 md:w-16 md:h-16 mx-auto flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600 mb-4">
                  <i className={`${item.icon} text-2xl`}></i>
                </div>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-foreground-500 text-xs md:text-sm leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full py-12 md:py-20 px-4 md:px-6 bg-background-50">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
              团队实力
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              专业团队，卓越服务
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
              我们的团队汇聚了来自体育数据、人工智能、用户体验等领域的顶尖人才
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {[
              {
                icon: 'ri-database-2-line',
                title: '数据团队',
                desc: '由资深体育统计学家和机器学习工程师组成，负责构建行业领先的足球数据分析系统。',
              },
              {
                icon: 'ri-broadcast-line',
                title: '直播团队',
                desc: '拥有丰富的体育赛事直播经验，确保每一场比赛都能高清、稳定、流畅地呈现给用户。',
              },
              {
                icon: 'ri-code-box-line',
                title: '技术团队',
                desc: '精通前沿Web技术与高并发架构，保障平台在大流量场景下的稳定运行。',
              },
              {
                icon: 'ri-pencil-ruler-line',
                title: '内容团队',
                desc: '资深足球记者与专业评论员组成，为用户提供深度、客观、有趣的足球资讯与分析。',
              },
              {
                icon: 'ri-user-smile-line',
                title: '运营团队',
                desc: '以用户为中心，策划丰富的线上活动与互动玩法，持续为用户创造价值。',
              },
              {
                icon: 'ri-shield-user-line',
                title: '风控团队',
                desc: '专业的风险管控专家，确保平台运营的公平性与安全性，维护良好的社区环境。',
              },
            ].map((team) => (
              <div key={team.title} className="p-6 rounded-2xl bg-background-100 hover:bg-background-200/70 transition-all duration-300">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-4">
                  <i className={`${team.icon} text-xl`}></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">
                  {team.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed">
                  {team.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="contact" className="w-full py-12 md:py-20 px-4 md:px-6 bg-foreground-950">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14">
            <div>
              <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100/20 text-primary-400 text-xs font-semibold mb-4">
                联系我们
              </span>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
                随时为您服务
              </h2>
              <p className="text-foreground-400 text-sm md:text-base leading-relaxed mb-8">
                无论您有任何问题、建议或合作意向，我们都乐于倾听。开云足球团队随时准备为您提供帮助。
              </p>

              <div className="flex flex-col gap-5">
                {[
                  {
                    icon: 'ri-mail-line',
                    title: '邮箱',
                    value: 'support@kaiyun-football.com',
                  },
                  {
                    icon: 'ri-phone-line',
                    title: '客服热线',
                    value: '400-888-6789（7×24小时）',
                  },
                  {
                    icon: 'ri-map-pin-line',
                    title: '总部地址',
                    value: '中国上海市浦东新区世纪大道100号',
                  },
                  {
                    icon: 'ri-customer-service-2-line',
                    title: '在线客服',
                    value: '官网右下角随时发起对话',
                  },
                ].map((contact) => (
                  <div key={contact.title} className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-foreground-800 text-background-300 flex-shrink-0">
                      <i className={`${contact.icon} text-lg`}></i>
                    </div>
                    <div>
                      <p className="text-foreground-500 text-xs mb-0.5">{contact.title}</p>
                      <p className="text-background-50 text-sm font-medium">{contact.value}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20customer%20service%20center%20with%20friendly%20professional%20atmosphere%2C%20sleek%20workspace%20with%20green%20and%20gold%20accent%20lighting%2C%20warm%20and%20inviting%20interior%20design%2C%20professional%20corporate%20photography%20with%20natural%20colors%20and%20clean%20aesthetic&width=800&height=600&seq=kaiyun-about-contact&orientation=landscape"
                alt="联系我们"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="w-full py-10 md:py-14 px-4 md:px-6 bg-background-50 border-t border-background-200">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
            <div className="text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mb-3">
                <i className="ri-file-list-3-line text-xl"></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">用户协议</h3>
              <p className="text-foreground-500 text-xs leading-relaxed mb-3">
                详细规定了用户使用开云足球平台的权利与义务，确保双方权益受到保护。
              </p>
              <Link to="/about" className="text-primary-600 hover:text-primary-700 text-xs font-medium transition-colors">
                查看详情 <i className="ri-arrow-right-line ml-1"></i>
              </Link>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600 mb-3">
                <i className="ri-lock-2-line text-xl"></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">隐私政策</h3>
              <p className="text-foreground-500 text-xs leading-relaxed mb-3">
                我们承诺保护用户的个人信息安全，不会将用户数据出售或泄露给第三方。
              </p>
              <Link to="/about" className="text-primary-600 hover:text-primary-700 text-xs font-medium transition-colors">
                查看详情 <i className="ri-arrow-right-line ml-1"></i>
              </Link>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-2xl bg-secondary-100 text-secondary-700 mb-3">
                <i className="ri-refund-2-line text-xl"></i>
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">责任博彩</h3>
              <p className="text-foreground-500 text-xs leading-relaxed mb-3">
                倡导健康理性的足球娱乐理念，提供完善的自我管理工具，帮助用户保持适度参与。
              </p>
              <Link to="/about" className="text-primary-600 hover:text-primary-700 text-xs font-medium transition-colors">
                查看详情 <i className="ri-arrow-right-line ml-1"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}